export const Group = {
  IDT: 'IDT',
  CARE_TEAM: 'CARE_TEAM',
  TECH: 'TECH',
  MOE: 'MOE',
  AUDITOR: 'AUDITOR',
} as const
export type Group = (typeof Group)[keyof typeof Group]

export const GROUP_LABELS = {
  [Group.IDT]: 'IDT',
  [Group.CARE_TEAM]: 'Care Team',
  [Group.TECH]: 'Tech',
  [Group.MOE]: 'MOE',
  [Group.AUDITOR]: 'Auditor',
} as const satisfies Record<Group, string>

export interface GroupPermsFlags {
  isMOE: boolean
  isTech: boolean
  isIDT: boolean
  isAuditor: boolean
}

export function getGroupOverridePerms(group?: Group): GroupPermsFlags {
  return {
    isIDT: group === Group.IDT,
    isMOE: group === Group.MOE,
    isTech: group === Group.TECH,
    isAuditor: group === Group.AUDITOR,
  }
}

export function getGroupPerms(groups: Group[]): GroupPermsFlags {
  const hasAuditorGroup = groups.some((group) => group === Group.AUDITOR)
  const hasNonAuditorGroup = groups.some((group) => group !== Group.AUDITOR)

  return {
    isIDT: groups.some((group) => group === Group.IDT),
    isMOE: groups.some((group) => group === Group.MOE),
    isTech: groups.some((group) => group === Group.TECH),
    isAuditor: hasAuditorGroup && !hasNonAuditorGroup,
  }
}
